import { capitalDesignTokens, createTypedSxStyles } from "@opengov/capital-mui-theme";

const { semanticColors, foundations } = capitalDesignTokens;

export const styles = createTypedSxStyles({
  card: {
    width: "100%",
    backgroundColor: semanticColors.background.primary,
    display: "flex",
    borderRadius: "3px",
    alignItems: "center",
    justifyContent: "space-between",
    border: "1px solid transparent",
    cursor: "pointer",
    padding: 0,
    textAlign: "left",
    font: "inherit",
    "&:hover": {
      borderColor: semanticColors.border.primary,
      boxShadow:
        "inset 0 1px 0 rgba(255,255,255,0.5), inset 0 -1px 3px rgba(34,102,139,0.15), 0 2px 2px rgba(0,0,0,0.08)",
    },
  },
  cardOpen: {
    borderBottom: `1px solid ${semanticColors.border.secondary}`,
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0,
    "&:hover": {
      borderBottomColor: semanticColors.border.primary,
    },
  },
  cardFocused: {
    borderColor: semanticColors.border.primary,
  },
  details: {
    backgroundColor: semanticColors.background.primary,
    borderRadius: "0 0 6px 6px",
  },
  titleWrapper: {
    flex: 1,
  },
  titleInner: {
    width: "calc(100% - 16px)",
    margin: "8px",
    "& .MuiInput-root": {
      "&::before": { display: "none" },
      "&::after": { display: "none" },
    },
    "& input": {
      fontSize: foundations.typography.fontSize.bodySmall,
      fontWeight: foundations.typography.fontWeight.bold,
      letterSpacing: "0.5px",
      textTransform: "uppercase",
      height: "30px",
      padding: "0 12px",
      borderRadius: "15px",
      overflow: "hidden",
      whiteSpace: "nowrap",
      textOverflow: "ellipsis",
      border: "none !important",
      outline: "none !important",
    },
  },
  icons: {
    display: "flex",
    alignItems: "center",
    paddingRight: "12px",
    gap: "16px",
  },
  iconColor: {
    color: semanticColors.foreground.action,
    fill: semanticColors.foreground.action,
    cursor: "pointer",
  },
  formatContainer: {
    textAlign: "center",
    padding: "16px",
  },
  formatActive: {
    backgroundColor: semanticColors.background.actionLight,
  },
  thumbnail: {
    display: "block",
    maxWidth: "100%",
  },
  thumbnailButton: {
    padding: 0,
    width: "auto",
    height: "auto",
    borderRadius: "4px",
    "&:focus-visible": {
      outline: `2px solid ${semanticColors.border.primary}`,
    },
  },
  buttonsRow: {
    display: "flex",
    flexWrap: "wrap",
    padding: "16px",
    gap: "8px",
  },
  draggingHidden: {
    opacity: 0,
  },
  draggingVisible: {
    opacity: 1,
  },
  switch: {
    "& .MuiSwitch-input, & .PrivateSwitchBase-input": {
      position: "absolute !important" as "absolute",
      width: "300% !important",
      height: "100% !important",
      left: "-100% !important",
      top: "0 !important",
      margin: "0 !important",
      padding: "0 !important",
      minHeight: "unset !important",
      border: "none !important",
      outline: "none !important",
    },
  },
});
